import { render, staticRenderFns } from "./HistoricoAtendimentos.vue?vue&type=template&id=42181abc"
import script from "./HistoricoAtendimentos.vue?vue&type=script&lang=ts"
export * from "./HistoricoAtendimentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports